import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  outfitters: [],
};

const getters = {
  getOutfitters: (state) => state.outfitters,
};

const actions = {
  async getOutfitters({ commit }) {
    const resp = await asyncHandler(
      HTTP({
        url: "public/outfitter/all",
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_outfitters", resp.outfitters);
    }
    return resp;
  },
};

const mutations = {
  set_outfitters: (state, outfitters) => {
    state.outfitters = outfitters;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
